import { Form, Select } from 'antd';
import React, { useCallback, useState, useEffect } from 'react';
import styles from '../../modalStyles.module.scss';

const AddressSelect = ({
  setFieldsValue,
  formKey,
  label,
  getFieldValue,
  valueFromLegalAddress,
  addresses,
  setSearch,
  loading,
  legalAddressKey,
  nameKey,
  defaultValue,
  placeholder,
}) => {
  const [params, setParams] = useState({});

  const onSelectAddress = useCallback(
    (obj) => {
      setFieldsValue({
        [formKey]: addresses?.find((dadataAddress) => {
          return +dadataAddress.id === +obj.key;
        }),
      });

      if (formKey === 'actualAddress') {
        setParams({ value: obj });
      }
    },
    [addresses, setFieldsValue, formKey]
  );

  const onAddressSearch = useCallback(
    (search) => setSearch(search),
    [setSearch]
  );

  const registrationAddress = getFieldValue(
    legalAddressKey || 'registrationAddress'
  );

  useEffect(() => {
    if (valueFromLegalAddress) {
      if (registrationAddress) {
        setFieldsValue({ actualAddress: registrationAddress });
        setParams({
          value: {
            key: registrationAddress?.id,
            label: registrationAddress?.fullAddress,
          },
        });
      }
    } else {
      if (formKey === 'actualAddress') {
        const actualAddress = getFieldValue('actualAddress');

        if (!actualAddress || actualAddress === registrationAddress) {
          setFieldsValue({ [formKey]: undefined });
          setParams({ value: undefined });
        }
      }
    }
  }, [
    valueFromLegalAddress,
    getFieldValue,
    legalAddressKey,
    setFieldsValue,
    formKey,
    registrationAddress
  ]);

  return (
    <>
      <Form.Item label={label} className={styles.flexFull}>
        <Select
          labelInValue
          defaultValue={
            defaultValue
              ? {
                  key: defaultValue.id,
                  label: defaultValue.fullAddress || defaultValue.fullCity,
                }
              : undefined
          }
          {...params}
          disabled={valueFromLegalAddress}
          onSelect={onSelectAddress}
          showSearch
          filterOption={false}
          onSearch={onAddressSearch}
          loading={loading}
          placeholder={placeholder || 'Введите улицу и дом'}
        >
          {addresses?.map((address) => {
            return (
              <Select.Option key={address.id}>{address[nameKey]}</Select.Option>
            );
          })}
        </Select>
      </Form.Item>
    </>
  );
};

export default AddressSelect;
